import Text from 'components/base/Text';

interface SectionTitleProps {
  title: string;
}

export function SectionTitle({ title }: SectionTitleProps) {
  return (
    <Text size='large' letterSpacing='0.05rem'>
      {title}
    </Text>
  );
}
